export default __webpack_public_path__ + "static/media/new4.21dd1339.JPG";